/* !
 * topicsSlider.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	// TOPICS詳細ページ以外のTOPICSスライダー
	const topicsSlider = () => {
		let PCslideNum = (document.querySelector('.prod-detail') || document.querySelector('.recruit-article-detail')) ? 3 : 4;
		const swiper = new Swiper('.topics-slider.swiper', {
			loop: false,
			loopAdditionalSlides: 1,
			effect: 'slide',
			speed: 500,
			autoplay: false,
			slidesPerView: 'auto',
			spaceBetween: 32,
			navigation: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			watchSlidesProgress: true,
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
				1025: {
					slidesPerView: PCslideNum,
					spaceBetween: 40,
					pagination: false,
				}
			}
		});
		FUNCTIONS.matchHeight(document.querySelectorAll('.topics-slider.swiper a'));
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topicsSliderFUNCTIONS = () => {
		topicsSlider();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topicsSliderFUNCTIONS(); }) : topicsSliderFUNCTIONS();

})(window.FUNCTIONS);
